import { useState } from 'react';

export default function SubmitCta() {
  const [notice, setNotice] = useState('');

  const handleClick = (message: string) => {
    setNotice(message);
    window.setTimeout(() => setNotice(''), 2600);
  };

  return (
    <section className="w-full px-4 py-14 md:px-6 md:py-20">
      <div className="relative overflow-hidden rounded-lg">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20dark%20green%20and%20crimson%20red%20layered%20shapes%20with%20soft%20grain%20texture%2C%20moody%20editorial%20background%20for%20a%20community%20poster%2C%20deep%20shadows%2C%20blurred%20organic%20forms%2C%20no%20text%2C%20cinematic%20low%20key%20lighting%2C%20harmonious%20composition&width=1600&height=700&seq=xg-cta-cover-01&orientation=landscape"
          alt="投稿与参与整理的氛围背景"
          title="参与整理 · 西瓜黑料社区投稿"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/55 to-black/40"></div>

        <div className="relative flex flex-col items-start px-6 py-12 md:px-14 md:py-16 lg:flex-row lg:items-center lg:justify-between">
          <div className="w-full max-w-2xl">
            <p className="flex items-center gap-2 font-label text-xs tracking-[0.2em] text-accent-300">
              <i className="ri-hand-heart-line text-sm"></i>
              JOIN IN
            </p>
            <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-white md:text-4xl">
              手上也有料？一起把它整理成能看的索引
            </h2>
            <p className="mt-4 font-label text-sm leading-relaxed text-white/80 md:text-base">
              你可以直接投稿新的爆料，也可以帮忙把已有的热帖补全时间线和细节。整理得越清楚，后面围观的人就越省事。
            </p>
          </div>

          <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row lg:mt-0 lg:w-auto lg:shrink-0">
            <button
              type="button"
              onClick={() => handleClick('投稿入口正在整理中，很快就能提交了。')}
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 cursor-pointer"
            >
              <i className="ri-send-plane-line text-base"></i>
              投稿爆料
            </button>
            <button
              type="button"
              onClick={() => handleClick('参与整理的报名通道稍后开放，先收藏这一页。')}
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-6 py-3.5 font-label text-sm font-medium text-white transition-colors hover:bg-white/20 cursor-pointer"
            >
              <i className="ri-user-add-line text-base"></i>
              申请参与整理
            </button>
          </div>
        </div>
      </div>

      {notice && (
        <div className="pointer-events-none fixed inset-x-0 bottom-8 z-50 flex justify-center px-4">
          <div className="animate-fade-up rounded-full border border-foreground-800 bg-foreground-950 px-5 py-2.5 font-label text-sm text-background-50">
            {notice}
          </div>
        </div>
      )}
    </section>
  );
}